<template>
  <div>
    <app-nav></app-nav>
    <p>Au sujet de websecretaire</p>
  </div>
</template>
<script>
import AppNav from './AppNav'
export default {
  name: 'about',
  components:{
    AppNav
  }
}
</script>



// WEBPACK FOOTER //
// about.vue?34105914